/** id 国家/地区落地页 */
export default {
  "label": "Indonesia",
  "path": "/locations/free-indonesia-vpn/",
  "hreflang": "id",
  "htmlLang": "id",
  "title": "Secure VPN – VPN Indonesia Gratis dengan IP Lokal",
  "description": "Gunakan Secure VPN untuk melindungi koneksi internet dan mengetahui cara mendapatkan alamat IP Indonesia. Periksa server yang tersedia dan panduan pengaturan VPN.",
  "h1": "VPN Indonesia Gratis untuk Mendapatkan IP Indonesia",
  "heroLead": "Unduh Secure VPN dan nikmati koneksi terenkripsi cepat untuk browsing, streaming, bermain game, dan melindungi privasi online.",
  "heroPoints": [
    "1 perangkat terlindungi",
    "Tanpa log & iklan",
    "Gratis tanpa batas",
    "Server VPN global"
  ],
  "heroCtaLabel": "Unduh APK",
  "privacyTitle": "Lindungi privasi dengan VPN gratis",
  "privacyLead": "Secure VPN adalah aplikasi sederhana yang membantu menjaga privasi Anda saat online. Hanya dengan satu ketukan, Anda dapat terhubung ke server aman, menyembunyikan alamat IP, dan lebih aman saat memakai Wi-Fi publik, jaringan seluler, atau internet rumah. Cocok untuk pengguna yang menginginkan perlindungan cepat tanpa pengaturan rumit.",
  "privacySubtitle": "Manfaat utama",
  "privacyBenefits": [
    {
      "title": "100% gratis dan tanpa batas",
      "desc": "Nikmati akses VPN tanpa batas harian atau biaya tersembunyi."
    },
    {
      "title": "Perlindungan Wi-Fi publik",
      "desc": "Tetap lebih aman saat memakai Wi-Fi di kafe, bandara, hotel, dan jaringan bersama."
    },
    {
      "title": "Kebijakan tanpa log",
      "desc": "Aktivitas online Anda tetap milik Anda. Kami tidak menyimpan riwayat situs saat VPN digunakan."
    }
  ],
  "featuresTitle": "Apa yang bisa dilakukan VPN gratis Secure",
  "featureCards": [
    {
      "title": "Keamanan online terenkripsi",
      "desc": "Lindungi data pribadi dan lalu lintas internet dengan enkripsi kuat."
    },
    {
      "title": "Server global cepat",
      "desc": "Terhubung ke server VPN berkecepatan tinggi untuk browsing, streaming, dan penggunaan harian."
    },
    {
      "title": "Banyak lokasi server",
      "desc": "Pilih server di berbagai negara dan nikmati koneksi stabil di mana saja."
    },
    {
      "title": "Koneksi satu ketuk",
      "desc": "Langsung terhubung ke server terbaik tanpa pengaturan rumit."
    },
    {
      "title": "Server di seluruh dunia",
      "desc": "Akses server VPN global yang cepat dan andal kapan pun dibutuhkan."
    },
    {
      "title": "Streaming lancar",
      "desc": "Nikmati video, siaran langsung, dan hiburan online dengan koneksi stabil."
    },
    {
      "title": "Performa berkecepatan tinggi",
      "desc": "Server yang dioptimalkan memberi koneksi cepat dan stabil untuk browsing dan game."
    },
    {
      "title": "100% gratis dan tanpa batas",
      "desc": "Nikmati akses VPN tanpa batas harian atau biaya tersembunyi."
    }
  ],
  "extraTitle": "Alasan lain memilih Secure VPN",
  "extraItems": [
    "Ringan dan mudah digunakan",
    "Perlindungan Wi-Fi publik",
    "Sembunyikan alamat IP",
    "Browsing tanpa batas",
    "Server cepat dan stabil"
  ],
  "extraCta": "Unduh APK",
  "extraPlayPrefix": "Download from",
  "dailyTitle": "Secure VPN dalam kehidupan online sehari-hari",
  "dailyScenes": [
    {
      "title": "Bermain tanpa batas jaringan",
      "tags": [
        "PUBG Mobile",
        "Call of Duty: Mobile",
        "Free Fire",
        "Mobile Legends"
      ]
    },
    {
      "title": "Panggilan video dan pesan privat",
      "tags": [
        "WhatsApp",
        "Telegram",
        "Skype",
        "Viber"
      ]
    },
    {
      "title": "Tetap aman di Wi-Fi publik",
      "tags": [
        "Wi-Fi publik",
        "Kantor",
        "Sekolah",
        "Bandara"
      ]
    },
    {
      "title": "Lindungi privasi online",
      "tags": [
        "Enkripsi kuat",
        "Sembunyikan alamat IP",
        "Kebijakan tanpa log",
        "Privasi dari ISP"
      ]
    }
  ],
  "installTitle": "Cara mengunduh dan menginstal aplikasi Secure VPN",
  "installLead": "Ikuti langkah sederhana berikut:",
  "installSteps": [
    {
      "title": "Buka halaman unduhan",
      "desc": "Kunjungi halaman unduhan Secure VPN atau toko aplikasi terpercaya untuk mendapatkan versi terbaru."
    },
    {
      "title": "Unduh Secure VPN",
      "desc": "Ketuk Unduh dan tunggu file APK atau aplikasi selesai diunduh."
    },
    {
      "title": "Aktifkan izin instalasi",
      "desc": "Untuk file APK, aktifkan izin Instal aplikasi tidak dikenal pada browser atau pengelola file."
    },
    {
      "title": "Instal aplikasi",
      "desc": "Buka file yang diunduh, ketuk Instal, dan tunggu proses selesai."
    },
    {
      "title": "Buka dan hubungkan",
      "desc": "Jalankan Secure VPN, pilih server, lalu ketuk Hubungkan untuk memulai koneksi aman."
    },
    {
      "title": "Nikmati browsing aman",
      "desc": "Lalu lintas internet Anda kini terlindungi. Browsing, streaming, game, dan Wi-Fi publik jadi lebih aman."
    }
  ],
  "installCta": "Unduh APK",
  "compareTitle": "Aplikasi Secure VPN vs proxy web gratis",
  "compareLead": "Aplikasi VPN dan proxy web gratis sama-sama membantu meningkatkan privasi, tetapi cara kerjanya berbeda. VPN melindungi seluruh perangkat dengan koneksi terenkripsi, sedangkan proxy web terutama untuk browser.",
  "compareNote": "Untuk penggunaan internet sehari-hari, aplikasi Secure VPN memberikan solusi yang lebih lengkap dan andal.",
  "compareHeaders": [
    "Fitur",
    "Aplikasi Secure VPN",
    "Proxy web gratis"
  ],
  "compareRows": [
    {
      "feature": "Instalasi",
      "vpn": "Instalasi aplikasi mudah",
      "proxy": "Tidak perlu instalasi"
    },
    {
      "feature": "Penggunaan",
      "vpn": "Melindungi semua aplikasi dan situs",
      "proxy": "Hanya bekerja di browser"
    },
    {
      "feature": "Privasi",
      "vpn": "Enkripsi kuat dan koneksi aman",
      "proxy": "Privasi browsing dasar"
    },
    {
      "feature": "Kecepatan",
      "vpn": "Server VPN yang dioptimalkan",
      "proxy": "Bergantung pada server proxy"
    },
    {
      "feature": "Perlindungan perangkat",
      "vpn": "Perlindungan seluruh perangkat",
      "proxy": "Hanya tingkat browser"
    }
  ],
  "privacyChoiceTitle": "Mana yang harus dipilih?",
  "privacyChoiceP1": "jika Anda menginginkan privasi lebih kuat, koneksi cepat, dan perlindungan seluruh perangkat.jika Anda menginginkan privasi lebih kuat, koneksi cepat, dan perlindungan seluruh perangkat.",
  "privacyChoiceP2": "jika hanya membutuhkan akses browser sementara untuk tugas sederhana.",
  "privacyChoiceP3": "Untuk penggunaan internet sehari-hari, aplikasi Secure VPN memberikan solusi yang lebih lengkap dan andal.",
  "reviewsTitle": "Dipercaya pengguna",
  "reviewsLead": "Secure VPN dipercaya pengguna di seluruh dunia karena koneksi yang cepat, stabil, dan aman. Server andal serta perlindungan privasi membantu browsing, streaming, bermain game, dan tetap terhubung setiap hari.",
  "reviews": [
    {
      "name": "James",
      "text": "Koneksinya cepat dan mudah digunakan. Saya bisa browsing dengan aman di mana saja."
    },
    {
      "name": "Emily",
      "text": "Secure VPN berjalan lancar dan menjaga koneksi tetap stabil di Wi-Fi publik."
    },
    {
      "name": "Daniel",
      "text": "Kecepatan bagus dan server andal untuk streaming, game, dan penggunaan harian."
    }
  ],
  "faqTitle": "Pertanyaan yang sering diajukan",
  "faqs": [
    {
      "q": "Apakah VPN memperlambat internet?",
      "a": "Kecepatan bisa sedikit menurun karena trafik melewati server aman. Biasanya perbedaannya kecil dan browsing, streaming, serta aplikasi tetap berjalan normal."
    },
    {
      "q": "Apakah SecureVPN aman?",
      "a": "SecureVPN mengenkripsi koneksi dan menyembunyikan alamat IP. Selalu unduh dari sumber terpercaya dan baca kebijakan privasinya."
    },
    {
      "q": "Apakah penggunaan VPN legal?",
      "a": "Di sebagian besar negara, VPN legal dan umum digunakan untuk privasi serta keamanan. Ikuti hukum dan aturan yang berlaku di wilayah Anda."
    },
    {
      "q": "Berapa lama saya bisa tetap terhubung?",
      "a": "Anda dapat memakai SecureVPN selama membutuhkan koneksi terlindungi. Batasannya dapat berbeda menurut versi aplikasi dan kondisi layanan."
    },
    {
      "q": "Bagaimana cara menggunakan Secure VPN?",
      "a": "Instal Secure VPN, buka aplikasinya, pilih server jika tersedia, lalu ketuk tombol hubungkan. Setelah terhubung, trafik melewati VPN."
    },
    {
      "q": "Apakah VPN memengaruhi baterai?",
      "a": "VPN dapat memakai sedikit daya tambahan karena koneksi tetap aktif. Pada umumnya dampaknya minimal untuk penggunaan harian."
    }
  ]
};
